<div class="layout-sidebar">
  <div #menuContainer class="layout-menu-container">
    <app-menu />
  </div>

  <!-- The foot of the menu (desktop): the signed-in person, which opens the user menu. It used to live in the
       top bar, which the desktop no longer has (Dan, 2026-10-16). -->
  <div class="rail-foot">
    <button
      #userMenuTrigger
      type="button"
      class="rail-user"
      aria-haspopup="dialog"
      [attr.aria-expanded]="userMenuOpen"
      aria-label="User menu"
      (click)="userMenu.toggle($event)">
      <span class="rail-avatar">{{ initials }}</span>
      <span class="rail-user-text">
        <span class="rail-user-name">{{ userName }}</span>
        <span class="rail-user-role">{{ userRole }}</span>
      </span>
      <i class="pi pi-angle-up rail-user-caret" aria-hidden="true"></i>
    </button>
    <!-- Collapse to the icon rail and back. Beside the account on the wide menu, under the avatar on the rail. -->
    <button
      type="button"
      class="rail-collapse"
      [attr.aria-label]="userPreferences.menuCollapsed() ? 'Expand menu' : 'Collapse menu'"
      [attr.aria-expanded]="!userPreferences.menuCollapsed()"
      [pTooltip]="userPreferences.menuCollapsed() ? 'Expand menu' : 'Collapse menu'"
      tooltipPosition="right"
      (click)="toggleMenuWidth()">
      <i class="pi" [class.pi-angle-double-left]="!userPreferences.menuCollapsed()" [class.pi-angle-double-right]="userPreferences.menuCollapsed()" aria-hidden="true"></i>
    </button>
    <p-popover
      #userMenu
      (onShow)="userMenuOpen = true; userMenuPanel.focusFirstControl()"
      (onHide)="userMenuOpen = false; userMenuPanel.returnFocus(userMenuTrigger)">
      <app-user-menu #userMenuPanel (closed)="userMenu.hide()" />
    </p-popover>
  </div>
</div>
